<template>
<div>
  <div class='mess'>{{ params.messages.VerifyText }}</div>
  <div class='NextTime' v-if="!canNext">{{nextTimeHtml}}</div>
  <span class='btnConfirmedUser' @click.prevent="$emit('confirmedUser')" v-if="canNext">{{ params.messages.nextTray }}</span>
  <div class='inputCode'><input type='text' name='verifyCode' placeholder='****' v-model="code"></div>
  <div class='errors'>{{errrs}}</div>
  <div class='sendWrap'>
    <button class='def-bt sendBtn' @click.prevent="checkCode">{{params.messages.VerifyBtn }}</button>
  </div>
</div>
</template>

<script>
export default {
  name: "confirmPhone",
  props:['params'],
  data() {
    return {
      errrs:"",
      nextTime:this.params.nextTime,
      stringTime:"",
      canNext:false,
      code:""
    };
  },
  computed:{
    nextTimeHtml() {
      return this.params.messages.nextTime.replace("#NEXT_TIME#", this.stringTime);
    },

  },
  methods: {
    setTime() {
      if(this.nextTime!==undefined) {
        let now = new Date();
        if(now.getTime()<(this.nextTime*1000)) {
          let hSec = ((this.nextTime*1000)-now.getTime())/1000;
          let h = Math.floor(hSec/3600);
          if(h!==0) {
            if(h<10) {
              h = '0'+h;
            }
          }
          let mSec = hSec%3600;
          let m = Math.floor(mSec/60);
          if(m!==0) {
            if(m<10) {
              m = '0'+m;
            }
          }
          let s = Math.floor(mSec%60);
          if(s<10) {
            s = '0'+s;
          }
          let html = "";
          if(h) {
            html+=h+":";
          }
          if(m) {
            html+=m+":";
          }
          html+=s;
          this.stringTime = html;
          setTimeout(()=>{
            this.setTime();
          },1004);
        } else {
          this.canNext=true;
        }
      }
    },
    checkCode() {
      axios.post("/ua-uk/ajax/common.php", {
        handler: 'stores.product.list',
        func: 'confirmUser',
        code: this.code
      }).then((response)=>{
        if(response.data.status) {
          this.$emit("confirmedUser");
        } else {
          this.errrs = response.data.message;
        }
        console.log(response);
      });
    }
  },
  updated() {
    this.nextTime = this.params.nextTime;
  },
  mounted() {
    this.nextTime = this.params.nextTime;
    this.setTime();
  }
}
</script>

<style scoped>
.sendBtn {
  display: inline-block;
}
.btnConfirmedUser {
  cursor: pointer;
}
</style>